var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a95cdc5"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["placeholder", "readonly"];
const _hoisted_2 = { class: "icon-wrapper" };
const _hoisted_3 = {
    key: 0,
    class: "option-list",
    ref: "list"
};
const _hoisted_4 = ["onClick"];
import { ref, computed, watch, nextTick } from "vue";
import { useBuiltRewardSuppliers, } from "src/shared/store/reward/supplier/composables";
import { useFuzzySearch } from "src/shared/store/common/fuzzy-search";
import { useArrayFilter, useArrayMap } from "@vueuse/core";
import { onClickOutside } from "@vueuse/core";
import Strings from "src/shared/Strings";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RewardSupplierIdListPicker',
    props: {
        modelValue: {},
        addMode: { type: Boolean }
    },
    emits: ["update:modelValue", "update:addMode", "focus-handled"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const searchQuery = ref("");
        const selectedOption = ref(null);
        const showOptions = ref(false);
        const target = ref(null);
        const input = ref(null);
        watch(() => props.addMode, (newValue) => __awaiter(this, void 0, void 0, function* () {
            if (newValue && input.value) {
                yield nextTick();
                input.value.focus();
            }
        }));
        onClickOutside(target, () => {
            toggleOptions();
        });
        const { rewardSuppliers } = useBuiltRewardSuppliers();
        const nonCollectibleRewardSuppliers = computed(() => {
            return useArrayFilter(rewardSuppliers, (rewardSupplier) => {
                return !rewardSupplier.tags.includes("internal:collectible-reward");
            }).value;
        });
        const searchableRewardSuppliers = computed(() => {
            return useArrayMap(nonCollectibleRewardSuppliers, (rewardSupplier) => ({
                value: rewardSupplier.id,
                displayName: Strings.capitalize(rewardSupplier.name) ||
                    undefined,
                faceValue: rewardSupplier.getFormattedValue() || rewardSupplier.face_value,
            })).value;
        });
        const filteredOptions = computed(() => {
            return useFuzzySearch(searchQuery, searchableRewardSuppliers.value, [
                "displayName",
                "value",
            ]).value.filter((option) => option.displayName !== undefined);
        });
        const selectOption = (option) => {
            if (!option || option.displayName === undefined) {
                return;
            }
            selectedOption.value = option;
            searchQuery.value = option.displayName;
            showOptions.value = false;
            const newSelections = [...props.modelValue, option.value];
            emits("update:modelValue", newSelections);
            emits("update:addMode", false);
            clearSelection();
        };
        const clearSelection = () => {
            selectedOption.value = null;
            searchQuery.value = "";
            showOptions.value = false;
            emits("update:addMode", false);
        };
        const handleFocus = () => {
            if (!selectedOption.value) {
                showOptions.value = true;
            }
        };
        const toggleOptions = () => {
            if (!selectedOption.value) {
                showOptions.value = !showOptions.value;
                emits("update:addMode", false);
            }
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", {
                class: "searchable-select",
                ref_key: "target",
                ref: target
            }, [
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: ((_a = selectedOption.value) === null || _a === void 0 ? void 0 : _a.displayName) || 'Search',
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                    onFocus: handleFocus,
                    readonly: !!selectedOption.value,
                    autofocus: "",
                    ref_key: "input",
                    ref: input
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1), [
                    [_vModelText, searchQuery.value]
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("i", {
                        class: _normalizeClass(selectedOption.value ? 'fal fa-times' : 'fal fa-chevron-down'),
                        onClick: _cache[1] || (_cache[1] = ($event) => (selectedOption.value ? clearSelection() : toggleOptions()))
                    }, null, 2 /* CLASS */)
                ]),
                (showOptions.value && !selectedOption.value && filteredOptions.value.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: option.value,
                                onClick: () => selectOption(option)
                            }, _toDisplayString(option.displayName) + " " + _toDisplayString(option.faceValue ? ` (${option.faceValue})` : ""), 9 /* TEXT, PROPS */, _hoisted_4));
                        }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */))
                    : _createCommentVNode("v-if", true)
            ], 512 /* NEED_PATCH */));
        };
    }
});
